module.exports = __webpack_public_path__ + "static/cx-slider3-fc67b30032a9c171578f11684213d590.jpeg";